module.exports = __webpack_public_path__ + "static/media/1.Petrol kerosine Operated.1e7e27a3.jpg";